"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coupons = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
class Coupons {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * List coupons
    * @returns {Promise<ResultFail|Array<CouponDO>|net.NetError|number>}
    */
    listUnsafe(includeInactive) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Coupons/List";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("includeInactive=" + encodeURIComponent(includeInactive));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_1.CouponDO(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * List coupons
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<CouponDO>>}
    */
    list(includeInactive, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.listUnsafe(includeInactive);
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Create coupon
    * @returns {Promise<ResultFail|CouponDO|net.NetError|number>}
    */
    createUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Coupons/Create";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.CouponDO(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Create coupon
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<CouponDO>}
    */
    create(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.createUnsafe(body);
                if (!(r instanceof models_1.CouponDO))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Update coupon
    * @returns {Promise<ResultFail|CouponDO|net.NetError|number>}
    */
    updateUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Coupons/Update";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.CouponDO(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Update coupon
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<CouponDO>}
    */
    update(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.updateUnsafe(body);
                if (!(r instanceof models_1.CouponDO))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Soft delete coupon
    * @returns {Promise<ResultFail|net.NetError|number>}
    */
    deleteUnsafe(couponId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Coupons/Delete";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("couponId=" + encodeURIComponent(couponId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.DELETE, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Soft delete coupon
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<number>}
    */
    delete(couponId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.deleteUnsafe(couponId);
                if (typeof r !== "number")
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Restore coupon
    * @returns {Promise<ResultFail|CouponDO|net.NetError|number>}
    */
    restoreUnsafe(couponId) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/admin/api/v1/Coupons/Restore";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("couponId=" + encodeURIComponent(couponId));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.CouponDO(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Restore coupon
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<CouponDO>}
    */
    restore(couponId, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.restoreUnsafe(couponId);
                if (!(r instanceof models_1.CouponDO))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.Coupons = Coupons;
//# sourceMappingURL=Coupons.js.map